import { Toast } from "@capacitor/toast";

import i18next from "i18next";
import { AdMob } from "@capacitor-community/admob";
import { Capacitor } from "@capacitor/core";

const colorDefault = {
  primary: "236 72 153",
  secondary: "244 63 94",
  headerPrimary: "236 72 153",
  headerSecondary: "244 63 94",
  textPrimary: "255 255 255",
  textSecondary: "0 0 0",
};

const colorBlue = {
  primary: "34 211 238",
  secondary: "14 165 233",
  headerPrimary: "34 211 238",
  headerSecondary: "14 165 233",
  textPrimary: "255 255 255",
  textSecondary: "0 0 0",
};

const colorGreen = {
  primary: "45 212 191",
  secondary: "34 211 238",
  headerPrimary: "45 212 191",
  headerSecondary: "34 211 238",
  textPrimary: "255 255 255",
  textSecondary: "0 0 0",
};

const colorOrange = {
  primary: "255 75 31",
  secondary: "255 144 104",
  headerPrimary: "255 75 31",
  headerSecondary: "255 144 104",
  textPrimary: "255 255 255",
  textSecondary: "0 0 0",
};

const colorLight = {
  primary: "239 244 248",
  secondary: "239 244 248",
  headerPrimary: "236 72 153",
  headerSecondary: "244 63 94",
  textPrimary: "0 0 0",
  textSecondary: "255 255 255",
};

const roundedDefault = {
  roundedNone: "0px",
  roundedSm: "0.125rem",
  roundedRegular: "0.25rem",
  roundedMd: "0.375rem",
  roundedLg: "0.5rem",
  roundedXl: "0.75rem",
  rounded2xl: "1rem",
  rounded3xl: "1.5rem",
  roundedFull: "9999px",
};
const secondaryDefault = {
  secondary100: "#f3f4f6",
  secondary200: "#e2e8f0",
  secondary300: "#cbd5e1",
  secondary400: "#94a3b8",
  secondary500: "#64748b",
  secondary600: "#475569",
  secondary700: "#334155",
  secondary800: "#1e293b",
  secondary900: "#0f172a",
};
const secondaryLight = {
  secondary100: "#f3f4f6",
  secondary200: "#e2e8f0",
  secondary300: "#cbd5e1",
  secondary400: "#94a3b8",
  secondary500: "#64748b",
  secondary600: "#475569",
  secondary700: "#334155",
  secondary800: "#1e293b",
  secondary900: "#0f172a",
};

export const themes = [
  {
    id: 0,
    ...colorLight,
    ...roundedDefault,
    ...secondaryLight,
    title: "Default",
  },
  {
    id: 1,
    ...colorBlue,
    ...roundedDefault,
    ...secondaryDefault,
    title: "Blue",
  },
  {
    id: 2,
    ...colorGreen,
    ...roundedDefault,
    ...secondaryDefault,
    title: "Green",
  },
  {
    id: 3,

    ...colorOrange,
    ...roundedDefault,
    ...secondaryDefault,
    title: "Orange",
  },
  {
    id: 4,
    ...colorDefault,
    ...roundedDefault,
    ...secondaryDefault,
    title: "Pink",
  },
];

export const languages = [
  { id: 0, value: "en", text: "English" },
  { id: 1, value: "es", text: "Spanish" },
  { id: 2, value: "de", text: "German" },
  { id: 3, value: "fr", text: "French" },
  { id: 4, value: "se", text: "Swedish" },
  { id: 5, value: "no", text: "Norwegian" },
  { id: 6, value: "it", text: "Italian" },
];

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function formatNumber(d) {
  if (d > 3 && d < 21) return d + i18next.t("lobby.card.ordinal.th");
  switch (d % 10) {
    case 1:
      return d + i18next.t("lobby.card.ordinal.st");
    case 2:
      return d + i18next.t("lobby.card.ordinal.nd");
    case 3:
      return d + i18next.t("lobby.card.ordinal.rd");
    default:
      return d + i18next.t("lobby.card.ordinal.th");
  }
}

function ColorToHex(color) {
  var hexadecimal = color.toString(16);
  return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
}

export function ConvertRGBtoHex(red, green, blue, opacity) {
  return (
    "#" +
    ColorToHex(parseInt(red)) +
    ColorToHex(parseInt(green)) +
    ColorToHex(parseInt(blue)) +
    opacity
  );
}
export function percentageToTailwind(number) {
  switch (number) {
    case 1:
      return "w-[1%]";
    case 2:
      return "w-[2%]";
    case 3:
      return "w-[3%]";
    case 4:
      return "w-[4%]";
    case 5:
      return "w-[5%]";
    case 6:
      return "w-[6%]";
    case 7:
      return "w-[7%]";
    case 8:
      return "w-[8%]";
    case 9:
      return "w-[9%]";
    case 10:
      return "w-[10%]";
    case 11:
      return "w-[11%]";
    case 12:
      return "w-[12%]";
    case 13:
      return "w-[13%]";
    case 14:
      return "w-[14%]";
    case 15:
      return "w-[15%]";
    case 16:
      return "w-[16%]";
    case 17:
      return "w-[17%]";
    case 18:
      return "w-[18%]";
    case 19:
      return "w-[19%]";
    case 20:
      return "w-[20%]";
    case 21:
      return "w-[21%]";
    case 22:
      return "w-[22%]";
    case 23:
      return "w-[23%]";
    case 24:
      return "w-[24%]";
    case 25:
      return "w-[25%]";
    case 26:
      return "w-[26%]";
    case 27:
      return "w-[27%]";
    case 28:
      return "w-[28%]";
    case 29:
      return "w-[29%]";
    case 30:
      return "w-[30%]";
    case 31:
      return "w-[31%]";
    case 32:
      return "w-[32%]";
    case 33:
      return "w-[33%]";
    case 34:
      return "w-[34%]";
    case 35:
      return "w-[35%]";
    case 36:
      return "w-[36%]";
    case 37:
      return "w-[37%]";
    case 38:
      return "w-[38%]";
    case 39:
      return "w-[39%]";
    case 40:
      return "w-[40%]";
    case 41:
      return "w-[41%]";
    case 42:
      return "w-[42%]";
    case 43:
      return "w-[43%]";
    case 44:
      return "w-[44%]";
    case 45:
      return "w-[45%]";
    case 46:
      return "w-[46%]";
    case 47:
      return "w-[47%]";
    case 48:
      return "w-[48%]";
    case 49:
      return "w-[49%]";
    case 50:
      return "w-[50%]";
    case 51:
      return "w-[51%]";
    case 52:
      return "w-[52%]";
    case 53:
      return "w-[53%]";
    case 54:
      return "w-[54%]";
    case 55:
      return "w-[55%]";
    case 56:
      return "w-[56%]";
    case 57:
      return "w-[57%]";
    case 58:
      return "w-[58%]";
    case 59:
      return "w-[59%]";
    case 60:
      return "w-[60%]";
    case 61:
      return "w-[61%]";
    case 62:
      return "w-[62%]";
    case 63:
      return "w-[63%]";
    case 64:
      return "w-[64%]";
    case 65:
      return "w-[65%]";
    case 66:
      return "w-[66%]";
    case 67:
      return "w-[67%]";
    case 68:
      return "w-[68%]";
    case 69:
      return "w-[69%]";
    case 70:
      return "w-[70%]";
    case 71:
      return "w-[71%]";
    case 72:
      return "w-[72%]";
    case 73:
      return "w-[73%]";
    case 74:
      return "w-[74%]";
    case 75:
      return "w-[75%]";
    case 76:
      return "w-[76%]";
    case 77:
      return "w-[77%]";
    case 78:
      return "w-[78%]";
    case 79:
      return "w-[79%]";
    case 80:
      return "w-[80%]";
    case 81:
      return "w-[81%]";
    case 82:
      return "w-[82%]";
    case 83:
      return "w-[83%]";
    case 84:
      return "w-[84%]";
    case 85:
      return "w-[85%]";
    case 86:
      return "w-[86%]";
    case 87:
      return "w-[87%]";
    case 88:
      return "w-[88%]";
    case 89:
      return "w-[89%]";
    case 90:
      return "w-[90%]";
    case 91:
      return "w-[91%]";
    case 92:
      return "w-[92%]";
    case 93:
      return "w-[93%]";
    case 94:
      return "w-[94%]";
    case 95:
      return "w-[95%]";
    case 96:
      return "w-[96%]";
    case 97:
      return "w-[97%]";
    case 98:
      return "w-[98%]";
    case 99:
      return "w-[99%]";
    case 100:
      return "w-[100%]";
  }
}

export function percentageToTailwindLeft(number) {
  switch (number) {
    case 1:
      return "left-[1%]";
    case 2:
      return "left-[2%]";
    case 3:
      return "left-[3%]";
    case 4:
      return "left-[4%]";
    case 5:
      return "left-[5%]";
    case 6:
      return "left-[6%]";
    case 7:
      return "left-[7%]";
    case 8:
      return "left-[8%]";
    case 9:
      return "left-[9%]";
    case 10:
      return "left-[10%]";
    case 11:
      return "left-[11%]";
    case 12:
      return "left-[12%]";
    case 13:
      return "left-[13%]";
    case 14:
      return "left-[14%]";
    case 15:
      return "left-[15%]";
    case 16:
      return "left-[16%]";
    case 17:
      return "left-[17%]";
    case 18:
      return "left-[18%]";
    case 19:
      return "left-[19%]";
    case 20:
      return "left-[20%]";
    case 21:
      return "left-[21%]";
    case 22:
      return "left-[22%]";
    case 23:
      return "left-[23%]";
    case 24:
      return "left-[24%]";
    case 25:
      return "left-[25%]";
    case 26:
      return "left-[26%]";
    case 27:
      return "left-[27%]";
    case 28:
      return "left-[28%]";
    case 29:
      return "left-[29%]";
    case 30:
      return "left-[30%]";
    case 31:
      return "left-[31%]";
    case 32:
      return "left-[32%]";
    case 33:
      return "left-[33%]";
    case 34:
      return "left-[34%]";
    case 35:
      return "left-[35%]";
    case 36:
      return "left-[36%]";
    case 37:
      return "left-[37%]";
    case 38:
      return "left-[38%]";
    case 39:
      return "left-[39%]";
    case 40:
      return "left-[40%]";
    case 41:
      return "left-[41%]";
    case 42:
      return "left-[42%]";
    case 43:
      return "left-[43%]";
    case 44:
      return "left-[44%]";
    case 45:
      return "left-[45%]";
    case 46:
      return "left-[46%]";
    case 47:
      return "left-[47%]";
    case 48:
      return "left-[48%]";
    case 49:
      return "left-[49%]";
    case 50:
      return "left-[50%]";
    case 51:
      return "left-[51%]";
    case 52:
      return "left-[52%]";
    case 53:
      return "left-[53%]";
    case 54:
      return "left-[54%]";
    case 55:
      return "left-[55%]";
    case 56:
      return "left-[56%]";
    case 57:
      return "left-[57%]";
    case 58:
      return "left-[58%]";
    case 59:
      return "left-[59%]";
    case 60:
      return "left-[60%]";
    case 61:
      return "left-[61%]";
    case 62:
      return "left-[62%]";
    case 63:
      return "left-[63%]";
    case 64:
      return "left-[64%]";
    case 65:
      return "left-[65%]";
    case 66:
      return "left-[66%]";
    case 67:
      return "left-[67%]";
    case 68:
      return "left-[68%]";
    case 69:
      return "left-[69%]";
    case 70:
      return "left-[70%]";
    case 71:
      return "left-[71%]";
    case 72:
      return "left-[72%]";
    case 73:
      return "left-[73%]";
    case 74:
      return "left-[74%]";
    case 75:
      return "left-[75%]";
    case 76:
      return "left-[76%]";
    case 77:
      return "left-[77%]";
    case 78:
      return "left-[78%]";
    case 79:
      return "left-[79%]";
    case 80:
      return "left-[80%]";
    case 81:
      return "left-[81%]";
    case 82:
      return "left-[82%]";
    case 83:
      return "left-[83%]";
    case 84:
      return "left-[84%]";
    case 85:
      return "left-[85%]";
    case 86:
      return "left-[86%]";
    case 87:
      return "left-[87%]";
    case 88:
      return "left-[88%]";
    case 89:
      return "left-[89%]";
    case 90:
      return "left-[90%]";
    case 91:
      return "left-[91%]";
    case 92:
      return "left-[92%]";
    case 93:
      return "left-[93%]";
    case 94:
      return "left-[94%]";
    case 95:
      return "left-[95%]";
    case 96:
      return "left-[96%]";
    case 97:
      return "left-[97%]";
    case 98:
      return "left-[98%]";
    case 99:
      return "left-[99%]";
    case 100:
      return "left-[100%]";
  }
}

export function percentageToTailwindTop(number) {
  switch (number) {
    case 1:
      return "top-[1%]";
    case 2:
      return "top-[2%]";
    case 3:
      return "top-[3%]";
    case 4:
      return "top-[4%]";
    case 5:
      return "top-[5%]";
    case 6:
      return "top-[6%]";
    case 7:
      return "top-[7%]";
    case 8:
      return "top-[8%]";
    case 9:
      return "top-[9%]";
    case 10:
      return "top-[10%]";
    case 11:
      return "top-[11%]";
    case 12:
      return "top-[12%]";
    case 13:
      return "top-[13%]";
    case 14:
      return "top-[14%]";
    case 15:
      return "top-[15%]";
    case 16:
      return "top-[16%]";
    case 17:
      return "top-[17%]";
    case 18:
      return "top-[18%]";
    case 19:
      return "top-[19%]";
    case 20:
      return "top-[20%]";
    case 21:
      return "top-[21%]";
    case 22:
      return "top-[22%]";
    case 23:
      return "top-[23%]";
    case 24:
      return "top-[24%]";
    case 25:
      return "top-[25%]";
    case 26:
      return "top-[26%]";
    case 27:
      return "top-[27%]";
    case 28:
      return "top-[28%]";
    case 29:
      return "top-[29%]";
    case 30:
      return "top-[30%]";
    case 31:
      return "top-[31%]";
    case 32:
      return "top-[32%]";
    case 33:
      return "top-[33%]";
    case 34:
      return "top-[34%]";
    case 35:
      return "top-[35%]";
    case 36:
      return "top-[36%]";
    case 37:
      return "top-[37%]";
    case 38:
      return "top-[38%]";
    case 39:
      return "top-[39%]";
    case 40:
      return "top-[40%]";
    case 41:
      return "top-[41%]";
    case 42:
      return "top-[42%]";
    case 43:
      return "top-[43%]";
    case 44:
      return "top-[44%]";
    case 45:
      return "top-[45%]";
    case 46:
      return "top-[46%]";
    case 47:
      return "top-[47%]";
    case 48:
      return "top-[48%]";
    case 49:
      return "top-[49%]";
    case 50:
      return "top-[50%]";
    case 51:
      return "top-[51%]";
    case 52:
      return "top-[52%]";
    case 53:
      return "top-[53%]";
    case 54:
      return "top-[54%]";
    case 55:
      return "top-[55%]";
    case 56:
      return "top-[56%]";
    case 57:
      return "top-[57%]";
    case 58:
      return "top-[58%]";
    case 59:
      return "top-[59%]";
    case 60:
      return "top-[60%]";
    case 61:
      return "top-[61%]";
    case 62:
      return "top-[62%]";
    case 63:
      return "top-[63%]";
    case 64:
      return "top-[64%]";
    case 65:
      return "top-[65%]";
    case 66:
      return "top-[66%]";
    case 67:
      return "top-[67%]";
    case 68:
      return "top-[68%]";
    case 69:
      return "top-[69%]";
    case 70:
      return "top-[70%]";
    case 71:
      return "top-[71%]";
    case 72:
      return "top-[72%]";
    case 73:
      return "top-[73%]";
    case 74:
      return "top-[74%]";
    case 75:
      return "top-[75%]";
    case 76:
      return "top-[76%]";
    case 77:
      return "top-[77%]";
    case 78:
      return "top-[78%]";
    case 79:
      return "top-[79%]";
    case 80:
      return "top-[80%]";
    case 81:
      return "top-[81%]";
    case 82:
      return "top-[82%]";
    case 83:
      return "top-[83%]";
    case 84:
      return "top-[84%]";
    case 85:
      return "top-[85%]";
    case 86:
      return "top-[86%]";
    case 87:
      return "top-[87%]";
    case 88:
      return "top-[88%]";
    case 89:
      return "top-[89%]";
    case 90:
      return "top-[90%]";
    case 91:
      return "top-[91%]";
    case 92:
      return "top-[92%]";
    case 93:
      return "top-[93%]";
    case 94:
      return "top-[94%]";
    case 95:
      return "top-[95%]";
    case 96:
      return "top-[96%]";
    case 97:
      return "top-[97%]";
    case 98:
      return "top-[98%]";
    case 99:
      return "top-[99%]";
    case 100:
      return "top-[100%]";
  }
}

export function percentageToTailwindBottom(number) {
  switch (number) {
    case 1:
      return "bottom-[1%]";
    case 2:
      return "bottom-[2%]";
    case 3:
      return "bottom-[3%]";
    case 4:
      return "bottom-[4%]";
    case 5:
      return "bottom-[5%]";
    case 6:
      return "bottom-[6%]";
    case 7:
      return "bottom-[7%]";
    case 8:
      return "bottom-[8%]";
    case 9:
      return "bottom-[9%]";
    case 10:
      return "bottom-[10%]";
    case 11:
      return "bottom-[11%]";
    case 12:
      return "bottom-[12%]";
    case 13:
      return "bottom-[13%]";
    case 14:
      return "bottom-[14%]";
    case 15:
      return "bottom-[15%]";
    case 16:
      return "bottom-[16%]";
    case 17:
      return "bottom-[17%]";
    case 18:
      return "bottom-[18%]";
    case 19:
      return "bottom-[19%]";
    case 20:
      return "bottom-[20%]";
    case 21:
      return "bottom-[21%]";
    case 22:
      return "bottom-[22%]";
    case 23:
      return "bottom-[23%]";
    case 24:
      return "bottom-[24%]";
    case 25:
      return "bottom-[25%]";
    case 26:
      return "bottom-[26%]";
    case 27:
      return "bottom-[27%]";
    case 28:
      return "bottom-[28%]";
    case 29:
      return "bottom-[29%]";
    case 30:
      return "bottom-[30%]";
    case 31:
      return "bottom-[31%]";
    case 32:
      return "bottom-[32%]";
    case 33:
      return "bottom-[33%]";
    case 34:
      return "bottom-[34%]";
    case 35:
      return "bottom-[35%]";
    case 36:
      return "bottom-[36%]";
    case 37:
      return "bottom-[37%]";
    case 38:
      return "bottom-[38%]";
    case 39:
      return "bottom-[39%]";
    case 40:
      return "bottom-[40%]";
    case 41:
      return "bottom-[41%]";
    case 42:
      return "bottom-[42%]";
    case 43:
      return "bottom-[43%]";
    case 44:
      return "bottom-[44%]";
    case 45:
      return "bottom-[45%]";
    case 46:
      return "bottom-[46%]";
    case 47:
      return "bottom-[47%]";
    case 48:
      return "bottom-[48%]";
    case 49:
      return "bottom-[49%]";
    case 50:
      return "bottom-[50%]";
    case 51:
      return "bottom-[51%]";
    case 52:
      return "bottom-[52%]";
    case 53:
      return "bottom-[53%]";
    case 54:
      return "bottom-[54%]";
    case 55:
      return "bottom-[55%]";
    case 56:
      return "bottom-[56%]";
    case 57:
      return "bottom-[57%]";
    case 58:
      return "bottom-[58%]";
    case 59:
      return "bottom-[59%]";
    case 60:
      return "bottom-[60%]";
    case 61:
      return "bottom-[61%]";
    case 62:
      return "bottom-[62%]";
    case 63:
      return "bottom-[63%]";
    case 64:
      return "bottom-[64%]";
    case 65:
      return "bottom-[65%]";
    case 66:
      return "bottom-[66%]";
    case 67:
      return "bottom-[67%]";
    case 68:
      return "bottom-[68%]";
    case 69:
      return "bottom-[69%]";
    case 70:
      return "bottom-[70%]";
    case 71:
      return "bottom-[71%]";
    case 72:
      return "bottom-[72%]";
    case 73:
      return "bottom-[73%]";
    case 74:
      return "bottom-[74%]";
    case 75:
      return "bottom-[75%]";
    case 76:
      return "bottom-[76%]";
    case 77:
      return "bottom-[77%]";
    case 78:
      return "bottom-[78%]";
    case 79:
      return "bottom-[79%]";
    case 80:
      return "bottom-[80%]";
    case 81:
      return "bottom-[81%]";
    case 82:
      return "bottom-[82%]";
    case 83:
      return "bottom-[83%]";
    case 84:
      return "bottom-[84%]";
    case 85:
      return "bottom-[85%]";
    case 86:
      return "bottom-[86%]";
    case 87:
      return "bottom-[87%]";
    case 88:
      return "bottom-[88%]";
    case 89:
      return "bottom-[89%]";
    case 90:
      return "bottom-[90%]";
    case 91:
      return "bottom-[91%]";
    case 92:
      return "bottom-[92%]";
    case 93:
      return "bottom-[93%]";
    case 94:
      return "bottom-[94%]";
    case 95:
      return "bottom-[95%]";
    case 96:
      return "bottom-[96%]";
    case 97:
      return "bottom-[97%]";
    case 98:
      return "bottom-[98%]";
    case 99:
      return "bottom-[99%]";
    case 100:
      return "bottom-[100%]";
  }
}

export function timeDiffCalc(dateFuture, dateNow) {
  if (dateFuture < dateNow) return null;
  let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

  // calculate days
  const days = Math.floor(diffInMilliSeconds / 86400);
  diffInMilliSeconds -= days * 86400;

  // calculate hours
  const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
  diffInMilliSeconds -= hours * 3600;

  // calculate minutes
  const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
  diffInMilliSeconds -= minutes * 60;
  let difference = "";
  if (days > 0) {
    if (days == 1) {
      difference += `${i18next.t("common.dayOne", {
        count: days,
      })} `;
    } else {
      difference += `${i18next.t("common.dayMultiple", {
        count: days,
      })} `;
    }
  } else if (hours > 0) {
    if (hours == 1) {
      difference += `${i18next.t("common.hoursOne", {
        count: hours,
      })} `;
    } else {
      difference += `${i18next.t("common.hoursMultiple", {
        count: hours,
      })} `;
    }
  } else if (minutes > 0) {
    if (minutes == 1) {
      difference += `${i18next.t("common.minutesOne", {
        count: minutes,
      })} `;
    } else {
      difference += `${i18next.t("common.minutesMultiple", {
        count: minutes,
      })} `;
    }
  }

  return difference;
}

export function subtractHours(numOfHours, date = new Date()) {
  date.setHours(date.getHours() - numOfHours);

  return date;
}

export async function showToast(toastText) {
  return await Toast.show({
    text: toastText,
    duration: "long",
  });
}

export async function showConsent() {
  //const consentInfo = await AdMob.requestConsentInfo();
  const consentInfo = await AdMob.requestConsentInfo({
    debugGeography: 1,
    testDeviceIdentifiers: ["2077ef9a63d2b398840261c8221a0c9b"],
  });

  if (consentInfo.isConsentFormAvailable && consentInfo.status === "REQUIRED") {
    const { status } = await AdMob.showConsentForm();

    console.log(status);
  }
}

export async function showReward({ type }) {
  const { status } = await AdMob.trackingAuthorizationStatus();

  let id;

  if (type == "create") {
    if (Capacitor.getPlatform() == "ios") {
      id = "ca-app-pub-4203154953373969/9872679722";
    } else if (Capacitor.getPlatform() == "android") {
      id = "ca-app-pub-4203154953373969/3881986449";
    }
  } else if (type == "join") {
    if (Capacitor.getPlatform() == "ios") {
      id = "ca-app-pub-4203154953373969/9749390799";
    } else if (Capacitor.getPlatform() == "android") {
      id = "ca-app-pub-4203154953373969/7668068653";
    }
  }
  let options = {
    adId: id,
    //isTesting: true,
  };

  try {
    await AdMob.prepareRewardVideoAd(options);
    await AdMob.showRewardVideoAd();
  } catch (e) {
    return e;
  }
}

export async function showInterstitial() {
  let id;
  if (Capacitor.getPlatform() == "ios") {
    id = "ca-app-pub-4203154953373969/4512487934";
  } else if (Capacitor.getPlatform() == "android") {
    id = "ca-app-pub-4203154953373969/8947961937";
  }

  let options = {
    adId: id,
    //isTesting: true,
  };
  try {
    await AdMob.prepareInterstitial(options);
    await AdMob.showInterstitial();
  } catch (e) {
    return e;
  }
}
